import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { ILoggedInUser } from '../../interfaces/common/loggedInUser';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { SearchDistanceChangesModel } from '../models/search-distance-changes.model';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DistanceService } from '../services/distance.service';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DistanceChangesModel } from '../models/distance-chanes.model';
import { PagedResult } from '../../shared/models/pagedResult.model';

@Component({
  selector: 'app-distance-between-locations-changes',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatProgressSpinnerModule, MatPaginatorModule, MatTableModule],
  templateUrl: './distance-between-locations-changes.component.html',
  styleUrl: './distance-between-locations-changes.component.scss'
})
export class DistanceBetweenLocationsChangesComponent implements OnInit {
  searchForm: FormGroup;
  user: ILoggedInUser;
  isAdmin: boolean = false;
  searchRequestParams: SearchParameters<SearchDistanceChangesModel>;
  isLoading: boolean = false;
  pagedData: PagedResult<DistanceChangesModel[]>;
  totalCount: number;
  pageSize: number = 10;
  pageIndex: number;
  dataSource: MatTableDataSource<DistanceChangesModel>;
  searchDone: boolean = false;
  displayedColumns: string[] = ['number', 'time', 'action', 'fromTown', 'toTown', 'distance', 'actionBy'];

  constructor(
    private userService: LoggedInUserService,
    private fb: FormBuilder,
    private distanceService: DistanceService, ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      employeeName: new FormControl(''),
      fromTown: new FormControl(''),
      toTown: new FormControl(''),
      distance: new FormControl(''),
      fromDate: new FormControl(''),
      toDate: new FormControl('')
    });

    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isAdmin = this.user.adminRight;        
      }      
    });
  }  

  submitForm(): void { 
    this.searchRequestParams = {
      query: {
        fromTown: this.searchForm.get('fromTown').value || '',
        toTown: this.searchForm.get('toTown').value || '',
        distance: this.searchForm.get('distance').value || 0,
        fromDate: this.searchForm.get('fromDate').value || null,
        toDate: this.searchForm.get('toDate').value || null
      },
      pageIndex: 0,
      pageSize: 10,
      userEmail: this.user.userEmail      
    };
    
    this.search();
  }

  search() {
    if(this.isAdmin){
      this.isLoading = true;
      this.distanceService.SeachDistanceChanges(this.searchRequestParams)
        .subscribe(data => {
          this.pagedData = data;
          this.pageSize = this.pagedData.pageSize;
          this.totalCount = this.pagedData.totalCount;      
          this.dataSource = new MatTableDataSource<DistanceChangesModel>(this.pagedData.items);
          this.isLoading = false;
          this.searchDone = true;
      });
    }
    else{
      this.dataSource = new MatTableDataSource<DistanceChangesModel>([]);
    }
  }
  
  public pageChangeEvent(event?: PageEvent){
      this.searchRequestParams.pageIndex = event.pageIndex;
      this.searchRequestParams.pageSize = event.pageSize;
      this.search();
    }  
}
